import { render, staticRenderFns } from "./policiesInfoPage.vue?vue&type=template&id=40801ea5&"
import script from "./policiesInfoPage.vue?vue&type=script&lang=js&"
export * from "./policiesInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./policiesInfoPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports